import { createSlice } from '@reduxjs/toolkit';
import { updateUser } from '../usersActions';


export const updateUserSlice = createSlice({
    name: 'updateUser',
    initialState: {
        data: {},
        error: '',
        loading: false
    },
    reducers: {
        clearState: () => ({ data: {} })
    },
    extraReducers: {
        [updateUser.pending]: (state) => ({
            ...state,
            error: '',
            loading: true
        }),
        [updateUser.fulfilled]: (state, { payload }) => ({
            ...state,
            loading: false,
            data: payload.data
        }),
        [updateUser.rejected]: (state, { payload }) => ({
            ...state,
            error: 'There is an error occured, please try again later !',
            loading: false
        })
    }
});


export default updateUserSlice.reducer;
export const { clearState } = updateUserSlice.actions;

